import React, { useMemo } from 'react';
import i18n from 'i18next';
import { CdnIcon } from '@shared/ui';
import { Sorting } from '../../../../enums';
const sortings = [Sorting.Price, Sorting.FlightTime, Sorting.Departure, Sorting.Arrival];
const getSortingLabels = (sorting) => {
    const sortingLabels = {
        [Sorting.Price]: {
            label: i18n.t('Results:Price'),
            icon: React.createElement(CdnIcon, { icon: "Info/Item Paid" })
        },
        [Sorting.Departure]: {
            label: i18n.t('Results:Departure time'),
            icon: React.createElement(CdnIcon, { icon: "Flight/Takeoff" })
        },
        [Sorting.FlightTime]: {
            label: i18n.t('Results:Flight time'),
            icon: React.createElement(CdnIcon, { icon: "Info/Time" })
        },
        [Sorting.Arrival]: {
            label: i18n.t('Results:Arrival'),
            icon: React.createElement(CdnIcon, { icon: "Flight/Land" })
        }
    };
    return sortingLabels[sorting];
};
export const useSortings = (currentSort) => {
    const _getSortingOption = (sorting) => (Object.assign({ value: String(sorting) }, getSortingLabels(sorting)));
    const sortingOptions = useMemo(() => sortings.map(_getSortingOption), []);
    const currentSorting = _getSortingOption(currentSort);
    return {
        currentSorting,
        sortingOptions
    };
};
